import { EVENT_TYPE } from '@hedepy/common/enums/EVENT_TYPE'
import type { Event } from '@hedepy/common/schemas/modules/event/event'
import Markdown from 'markdown-to-jsx'

import Icon from '@/legacy-src/components/icons/Icon'
import { dayjs } from '@/legacy-src/lib/dayjs/day'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { ButtonIcon } from '@/src/domains/design-system/components/Button'
import { Text } from '@/src/domains/design-system/components/Text'
import { AppointmentTypeIcon } from '@/src/domains/appointments/components/AppointmentTypeIcon'

export interface ClientBookingRebookingNotificationUIProps {
  event: Event
  onCancel: () => void
}

export const ClientBookingRebookingNotificationUI = ({
  event,
  onCancel,
}: ClientBookingRebookingNotificationUIProps) => {
  const { t } = getTranslate()

  const startDate = dayjs(event.startDate)

  return (
    <div className="relative mb-10 flex items-center gap-3 rounded-xl bg-petrol-500 p-5 text-white-500">
      <Icon icon="next-day" size={24} className="!hidden shrink-0 tablet:!block" />

      <div className="flex w-full flex-col justify-between gap-4 tablet:flex-row tablet:items-center tablet:gap-2">
        <div className="flex flex-col gap-2 tablet:max-w-[27rem] tablet:gap-0">
          <Text element="h3" variant="lg" weight="bold" className="w-[calc(100%-1rem)] tablet:w-auto">
            <Icon icon="next-day" size={24} className="mr-3 tablet:hidden" />
            {t('calendar.toolbarInfo.rebooking')}
          </Text>
          <Text element="p" variant="sm">
            <Markdown
              options={{
                wrapper: 'span',
              }}
            >
              {event.type === EVENT_TYPE.ONLINE
                ? t('calendar.toolbarInfo.rebooking-desc.online')
                : t('calendar.toolbarInfo.rebooking-desc.offline')}
            </Markdown>
          </Text>
        </div>
        <div className="shrink-0">
          <Text element="p">
            <span className="mb-1 block tablet:inline">{t('component.rebooking.currentDate')}: </span>
            {event?.type !== undefined ? <AppointmentTypeIcon type={event.type} className="align-bottom" /> : null}{' '}
            {startDate.format('L - LT')}
          </Text>
        </div>
      </div>
      <div>
        <ButtonIcon size="small" variant="petrol" onClick={onCancel} className="absolute right-0 top-0 tablet:hidden">
          <Icon icon="cross" color="primary" />
        </ButtonIcon>
        <ButtonIcon
          size="medium"
          variant="petrol"
          onClick={onCancel}
          className="hidden tablet:-ml-3 tablet:-mr-4 tablet:flex"
        >
          <Icon icon="cross" color="primary" />
        </ButtonIcon>
      </div>
    </div>
  )
}
